import { basePath, apiVersion } from "./config";

export function getCommentsApi(token){
    const url = `${basePath}/${apiVersion}/get-comments`;

    const params = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: token
        }
    };
  
    return fetch(url, params)
      .then(response => {
        return response.json();
      })
      .then(result => {
        return result;
      })
      .catch(err => {
        return err;
    });
}

export function getCommentApi(token, id) {
    const url = `${basePath}/${apiVersion}/get-comment/${id}`;

    const params = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: token
        }
    };
  
    return fetch(url, params)
      .then(response => {
        return response.json();
      })
      .then(result => {
        return result;
      })
      .catch(err => {
        return err;
    });
}

export function deleteCommentApi(token, id) {
    const url = `${basePath}/${apiVersion}/delete-post/${id}`;

    const params = {
        method: "DELETE",
        headers: {
        "Content-Type": "application/json",
        Authorization: token
        }
    };

    return fetch(url, params)
        .then(response => {
        return response.json();
        })
        .then(result => {
        return result;
        })
        .catch(err => {
        return err;
    });
}

export function getCommentsByPostsApi(token){
  const url = `${basePath}/${apiVersion}/get-commentsbyposts`;

  const params = {
      method: "GET",
      headers: {
      "Content-Type": "application/json",
      Authorization: token
      }
  };

  return fetch(url, params)
    .then(response => {
      return response.json();
    })
    .then(result => {
      return result;
    })
    .catch(err => {
      return err;
  });
}

export function getCommentsByPubApi(token, id){
  const url = `${basePath}/${apiVersion}/get-commentsbypub/${id}`;

  const params = {
      method: "GET",
      headers: {
      "Content-Type": "application/json",
      Authorization: token
      }
  };

  return fetch(url, params)
    .then(response => {
      return response.json();
    })
    .then(result => {
      return result;
    })
    .catch(err => {
      return err;
  });
}

export function restoreDataPostApi(token, id) {
  const url = `${basePath}/${apiVersion}/restore-post/${id}`;

  const params = {
      method: "DELETE",
      headers: {
      "Content-Type": "application/json",
      Authorization: token
      }
  };

  return fetch(url, params)
      .then(response => {
      return response.json();
      })
      .then(result => {
      return result;
      })
      .catch(err => {
      return err;
  });
}

export function getCommentsStatsApi(token){
  const url = `${basePath}/${apiVersion}/get-comments-stats`;

  const params = {
      method: "GET",
      headers: {
      "Content-Type": "application/json",
      Authorization: token
      }
  };

  return fetch(url, params)
    .then(response => {
      return response.json();
    })
    .then(result => {
      return result;
    })
    .catch(err => {
      return err;
  });
}

export function setLikePostApi(id) {
  const url = `${basePath}/${apiVersion}/set-like-post/${id}`;

  const params = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    }
  };

  return fetch(url, params)
    .then(response => {
      return response.json();
    })
    .then(result => {
      return result;
    })
    .catch(err => {
      return err;
    });
}

export function setDislikePostApi(id, data) {
  const url = `${basePath}/${apiVersion}/set-dislike-post/${id}`;

  const params = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  };

  return fetch(url, params)
    .then(response => {
      return response.json();
    })
    .then(result => {
      return result;
    })
    .catch(err => {
      return err;
    });
}